interface BindState {
  memberId: string
  phoneNumber: string
  otp: string
  isEmailVerified: boolean
  jwtForLogoutSession: string
}

const state: BindState = {
  memberId: '',
  phoneNumber: '',
  otp: '',
  isEmailVerified: false,
  jwtForLogoutSession: ''
};

export default {
  state,
  getters: {},
  actions: {},
  mutations: {
    setMemberId(state: BindState, memberId: string) {
      state.memberId = memberId;
    },
    setPhoneNumber(state: BindState, phoneNumber: string) {
      state.phoneNumber = phoneNumber;
    },
    setOtp(state: BindState, Otp: string) {
      state.otp = Otp;
    },
    setIsEmailVerified(state: BindState, isEmailVerified: boolean) {
      state.isEmailVerified = isEmailVerified;
    },
    setJwt(state: BindState, jwt: string) {
      state.jwtForLogoutSession = jwt;
    },
    clearJwt(state: BindState) {
      state.jwtForLogoutSession = '';
    }
  },
  namespaced: true
};